<template>
  <div class="guide-page-wrap">
    <div class="guimain">
      <div class="guidheader">
        <div class="top">
          <ul>
            <li><img src="../assets/img/tou.png" width="93" height="124"></li>
            <li>
              <p>账户名：{{ user.Account }}</p>
              <p>姓名：{{ user.Name }}</p>
              <p>性别：</p>
            </li>
            <li style="float:right;padding-right:20px">
              <span class="action">倒计时：&nbsp;&nbsp;{{hour}}：{{minute}}：<span class="second" style="font-size: 20px;">{{ second }} </span></span>
              <span  @click="skip" style="margin-left:10px;padding-bottom:1px;cursor: pointer;font-size: 20px;color: #fff;border-bottom: 2px solid white;">跳过</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="down">
        <h3>公务员录用电子化考试</h3>
        <ul class="change">
          <li class="two" :class="activeIndex==='1'?'current':''" @click="handleClick('1')"><a href="javascript:;">考生须知</a></li>
          <li class="two" :class="activeIndex==='2'?'current':''" @click="handleClick('2')"><a href="javascript:;">考场规则</a></li>
        </ul>
        <div class="content" style="height: 476px;">
          <div class="know" :style="{display:activeIndex==='1'?'block':'none'}">
            <span style="color:red">*注：要用电脑浏览器答题，建议使用<b>谷歌，qq，360浏览器</b>，并在<b>良好稳定的网络环境</b>下参加考试。</span><br>
            <p style="font-size: 16px;">一、本次考试行政职业能力测验实行电子化考试，使用计算机作答，申论和公安专业科目实行纸笔化考试。</p>
            <p style="font-size: 16px;">二、行政职业能力测验科目实行每部分分别计时的考试方式，考试系统提供两个计时：总考试时间倒计时和各部分考试时间倒计时。</p>
            <p style="font-size: 16px;">三、考生在考试开始前按照提示登陆考试系统，考试开始后，系统自动开始计时。行政职业能力测验由若干部分试题内容组成，各部分作答单独计时。除“知觉速度与准确性”部分必须在第一部分作答外，常规模式考生可自行选择剩余部分的作答顺序，随机模式则由系统自动选择作答顺序。</p>
            <p style="font-size: 16px;">四、考生选择某一部分进入后，无论是否作答，退出后都不允许返回该部分查看或再次作答，请考生务必确认后，再提交该部分试题；考生选择进入某一部分后，须在指定时限内完成该部分的答题，到达时限后，系统自动提交该部分试题。考生在该部分作答时限内自行提交的，该部分剩余的答题时间不累积到其他部分。交卷由考试系统自动完成。</p>
            <p style="font-size: 16px;">五、考试开始前30分钟，凭准考证和身份证进入考场，对号入座。考试开始30分钟后一律禁止入场，不允许提前交卷、退场。</p>
            <p style="font-size: 16px;">六、除规定可携带的文具以外，严禁将各种电子、通信、计算、存储或其它设备带至座位。</p>
            <p style="font-size: 16px;">七、考生应按考试系统要求或提示进行操作，不得擅自对计算机进行冷、热启动、关闭电源及其他与考试无关的操作。在电子化考试过程中，如出现无法登录、信息有误、系统故障、停电等异常情况，应举手示意，请监考人员解决，不得自行处置。在异常情况处理期间，考生应在座位上安静等待，听从监考人员和系统管理员的指引。根据处置时间，会给考生相应地延长考试时间。</p>
            <p style="font-size: 16px;">八、违纪违规行为按照《公务员考试录用违纪违规行为处理办法》中有关规定处理。</p>
          </div>
          <div class="rule" :style="{display:activeIndex==='2'?'block':'none'}">
            <span style="color:red">*注：请尽量使用<b>谷歌浏览器</b>，并在<b>良好稳定的网络环境</b>下参加考试。</span><br>
            一、考试开始前30分钟，应试人员可凭准考证和本人有效身份证件进入指定考场，按座位号入座。入座后，须将准考证和身份证件放置在桌面右上角。<br>二、严禁应试人员携带笔、移动存储设备、电脑、计算器、电子记事本、通讯工具和其他规定以外的电子用品或者与考试相关的资料进入座位。<br>三、考试时间以考试系统计时器显示的时间为准。开考后，考生交卷、离场的时间按相关考务规定执行。<br>四、应试人员须按照考试系统或监考人员提示的要求进行操作，不得擅自对计算机进行冷、热启动，不得擅自关闭电源或作出其他与考试无关的操作，违反者责任自负。<br>五、应试人员在考场内须保持安静，独立作答，不得与其他应试人员交流讨论，不得要求监考人员解释试题，发生异常情况等问题时可举手询问。<br>六、应试人员须自觉接受考试监督和检查，服从工作人员安排。<br>七、应试人员不得以任何方式将考试相关信息带出考场，交卷后不得在考场附近逗留、谈论。<br>八、若有违纪违规行为，应试人员须接受考试管理部门或工作人员按照《专业技术人员资格考试违纪违规行为处理规定》（人力资源和社会保障部令第31号）等规定作出的有关处理。<br>
          </div>
        </div>
        <div class="btn" @click="toExam"><a href="javascript:;" id="goExam" :style="{'background-color': msec===0?'#17b7f2':'#a4e4fb'}">我已阅读，开始考试</a></div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
export default {
  name: 'GuidePage',
  components: {
    Header
  },
  data() {
    return {
      user:JSON.parse(sessionStorage.getItem('userInfo')),
      endTime: 0,
      hour: '00',
      minute: '00',
      second: '00',
      interval: null,
      activeIndex: '1',
      msec: 1
    };
  },
  mounted() {
    //结束时间
    this.endTime = Date.parse(new Date()) + 15 * 1000;
    //开始倒计时
    this.countdown();
  },
  beforeDestroy() {
    //提前结束则销毁倒计时
    clearTimeout(this.interval);
  },
  methods: {
    skip(){
      clearTimeout(this.interval);
      this.hour='00';
      this.minute='00';
      this.second='00';
      this.msec=0
      this.$router.push({
        path: 'StartExam',
        query: {
          examID: this.$route.query.examID
        }
      })
    },
    countdown() {
      //计算运行时间
      const end = this.endTime;
      const now = Date.parse(new Date());
      this.msec = end - now;
      //计算剩余时间
      this.second = (this.msec / 1000) % 60;
      if (this.second < 10) this.second = '0' + this.second
      this.minute = parseInt((this.msec / 1000 / 60) % 60);
      if (this.minute < 10) this.minute = '0' + this.minute
      this.hour = parseInt(this.msec / 1000 / 60 / 60);
      if (this.hour < 10) this.hour = '0' + this.hour
      const that = this;
      //结束则弹框
      if (this.msec > 0) {
        //进入下一秒倒计时
        this.interval = setTimeout(that.countdown, 1000);
      }
      if (this.second < 0) {
        this.second = '00'
        this.msec = 0
      }
    },
    handleClick(value) {
      this.activeIndex=value
    },
    //跳转试题
    toExam() {
      this.$router.push({
        path: 'StartExam',
        query: {
          examID: this.$route.query.examID
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.app>div {
  height: 100%;
}
.guimain {
    width: 1025px;
    margin: 0 auto;
    border: 1px solid #4da8db;
}
.guidheader {
    background-color: #17b7f2;
}
.down {
    padding: 10px 17px;
}
.guidheader .top {
    overflow: hidden;
    zoom: 1;
    padding: 11px 17px 30px;
}
ol, ul {
    list-style: none;
}
.guidheader .top li {
    float: left;
    padding-right: 12px;
}
.guidheader .top li p {
    font-size: 16px;
    color: rgb(255, 255, 255);
    font-family: 宋体;
    line-height: 27px;
    padding-right: 80px;
}
.down > h3 {
    font-size: 36px;
    color: #fb7419;
    font-weight: bold;
    text-align: center;
    width: 800px;
    margin: 10px auto;
}
.down .change {
    overflow: hidden;
    zoom: 1;
    margin-bottom: -1px;
}

.down .change li {
    float: left;
    padding: 10px 45px;
    cursor: pointer;
    background: #f9f9f8;
    color: #363736;
    border: 1px solid #d7d7d7;
    z-index: 9999;
}
.down .change li.current {
    background: #fff;
    border-bottom: 1px solid #fff;
}
// .down .change .two {
//     margin-left: -1px;
// }
.down .change li > a {
    text-decoration: none;
    outline: none;
    color: #555;
    text-decoration: none;
    font-size: 16px;
}
.down .content {
    color: rgb(30, 31, 30);
    line-height: 36px;
    font-size: 16px;
    font-family: 宋体;
    height: 525px;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(215, 215, 215);
    border-image: initial;
    overflow: hidden;
    padding: 15px 40px;
    overflow-y: scroll;
    background: #fafafa;
}
.down .btn {
    text-align: center;
}
.down .btn a {
    margin: 10px auto;
    padding: 0px 15px;
    height: 35px;
    line-height: 35px;
    display: inline-block;
    text-align: center;
    color: #fff;
    background-color: #17b7f2;
    font-size: 18px;
    font-weight: 800;
    text-decoration: none;
}
.guidheader .top li .action {
    width: 265px;
    height: 58px;
    color: #fff;
    font-size: 20px;
    border: 2px solid #fff;
    border-radius: 5px;
    margin-left: 40px;
    font-weight: bold;
    background-color: #FB7A19;
    padding: 5px;
    text-align: center;
    line-height: 42px;
}
</style>